import {
  RequestWrapper, extPost,
} from '../dataSource/requests';
import {
  CHECK_REGISTRATION_URL,
  SAP_GET_MATRICULATION_CREDIT_BALANCE_URL,
  CHECK_REGISTRATION_USERNAME,
  CHECK_REGISTRATION_PASSWORD,
  FIDELITY_GET_PRODUCTS_BY_SEGMENT_ENDPOINT,
  FIDELITY_GET_SEGMENTS_ENDPOINT,
  SAP_LIST_ACCOUNTS_PAYABLE_URL,
  SAP_DOWNLOAD_SEND_BANK_SLIP_URL,
  SAP_GET_DATA_USER,
} from './constants';

const TIMEOUT_RESPONSE = 7000;
const TIMEOUT_DEADLINE = 10000;

const checkMatriculation = (matriculation: string): RequestWrapper => {
  if (!matriculation) {
    throw new Error('Erro. Matricula não informada');
  }
console.log('checa matricula no SAP');
  return extPost({
    url: CHECK_REGISTRATION_URL,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: {
      CODMATRICULA: matriculation,
    },

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });

};

const checkFidelityBalance = (matriculation: string): RequestWrapper => {
  return extPost({
    url: SAP_GET_MATRICULATION_CREDIT_BALANCE_URL,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: {
      CODMATRICULA: matriculation,
    },

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });
};

const getSegments = (): RequestWrapper => {
  return extPost({
    url: FIDELITY_GET_SEGMENTS_ENDPOINT,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: {},

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });
};

const getProductsBySegment = (segmentValue: string): RequestWrapper => {
  return extPost({
    url: FIDELITY_GET_PRODUCTS_BY_SEGMENT_ENDPOINT,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: {
      ROWS: [
        {
          CODIGO: segmentValue,
        },
      ],
    },

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });
};

const listAccountsPayable = (
  filters = {
    registration: '',
    issueDateStart: '',
    issueDateEnd: '',
    expirationDateStart: '',
    expirationDateEnd: '',
    companyCode: '',
    companyDescription: '',
    subsidiaryCode: '',
    subsidiaryDescription: '',
    cooperativeCode: '',
    cooperativeDescription: '',
    federalRegistration: '',
    documentNumber: '',
    status: '',
  },
): RequestWrapper => {
  return extPost({
    url: SAP_LIST_ACCOUNTS_PAYABLE_URL,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: {
      CODMATRICULA: filters.registration,
      DATAEMI_INI: filters.issueDateStart,
      DATAEMI_FIN: filters.issueDateEnd,
      DATAVEN_INI: filters.expirationDateStart,
      DATAVEN_FIN: filters.expirationDateEnd,
      EMPRESA: filters.companyCode,
      DESC_EMPRESA: filters.companyDescription,
      FILIAL: filters.subsidiaryCode,
      DESC_FILIAL: filters.subsidiaryDescription,
      COOPERADO: filters.cooperativeCode,
      DESC_COOPERADO: filters.cooperativeDescription,
      CPFCNPJ: filters.federalRegistration,
      NUMDOC: filters.documentNumber,
      STATUS: filters.status,
    },

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });
};

const sendBankSlipToEmail = (
  params = {
    companyCode: '',
    cooperativeCode: '',
    numeroTitulo: '',
    installmentNumber: '',
  },
): RequestWrapper => {
  return extPost({
    url: SAP_DOWNLOAD_SEND_BANK_SLIP_URL,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: {
      EMPRESA: params.companyCode,
      COOPERADO: params.cooperativeCode,
      NUMTITULO: params.numeroTitulo,
      PARCELA: params.installmentNumber,
      ENVIAR_EMAIL: true,
    },

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });
};

const downloadBankSlip = (
  params = {
    companyCode: '',
    cooperativeCode: '',
    numeroTitulo: '',
    installmentNumber: '',
  },
): RequestWrapper => {
  return extPost({
    url: SAP_DOWNLOAD_SEND_BANK_SLIP_URL,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: {
      EMPRESA: params.companyCode,
      COOPERADO: params.cooperativeCode,
      NUMTITULO: params.numeroTitulo,
      PARCELA: params.installmentNumber,
      ENVIAR_EMAIL: false,
    },

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });
};

const getDataUserSAP = (
  params = {
    bpRegistration: '',
    federalRegistration: '',
    type: 'federalRegistration',
  },
): RequestWrapper => {
  const requestPayload: {
    PARTNER?: string,
    CPF_CNPJ?: string,
  } = {};
  const allowedTypes = ['bp', 'federalRegistration'];

  if (!params?.bpRegistration && !params.federalRegistration) {
    throw new Error('Erro. BP ou documento não informado.');
  }

  if (!params?.type) {
    throw new Error('Erro. Tipo de pesquisa não informado.');
  }

  if (!allowedTypes.includes(params.type)) {
    throw new Error(`Erro. Tipo inválido: "${params.type}". Tipos de pesquisa disponiveis: ${allowedTypes.join(', ')}.`);
  }

  switch (true) {
    case (params.type === 'bp'):
      // 0001136253 | 0001002068
      requestPayload.PARTNER = params.bpRegistration;
      break;

    case (params.type === 'federalRegistration'):
    default:
      // 00831373003715 | 04269667834
      requestPayload.CPF_CNPJ = params.federalRegistration;
      break;
  }
  //console.log(CHECK_REGISTRATION_USERNAME);
  //console.log(CHECK_REGISTRATION_PASSWORD);
  return extPost({
    url: SAP_GET_DATA_USER,

    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${Buffer.from(`${CHECK_REGISTRATION_USERNAME}:${CHECK_REGISTRATION_PASSWORD}`).toString('base64')}`,
    },

    params: requestPayload,

    timeout: {
      response: TIMEOUT_RESPONSE, // Wait 7 seconds for the server to start sending,
      deadline: TIMEOUT_DEADLINE, // but allow 10 seconds for the file to finish loading.
    },
  });
};

export {
  checkMatriculation,
  checkFidelityBalance,
  getSegments,
  getProductsBySegment,
  listAccountsPayable,
  sendBankSlipToEmail,
  downloadBankSlip,
  getDataUserSAP,
};
